import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import TypographyText from '../../../common/TypographyText';
import React, { useState } from 'react';
import CcCluster from '../../../services/models/CcCluster';
import { FormInstance } from 'antd/lib/form';
import usePBMSetup from './usePBMSetup';
import CcJob from '../../../services/models/CcJob';
import BackupToolPromoCard from './BackupToolPromoCard';
import BackupToolJobProgress from './BackupToolJobProgress';
import BackupToolPBMSetupForm from './BackupToolPBMSetupForm';
import AppSpin from '../../../common/General/AppSpin';

export default BackupToolPBMSetup;
type BackupToolPBMInstallProps = {
    cluster: CcCluster;
    form: FormInstance;
    onFormShow?: () => void;

    onFinish?: (job: CcJob) => void;
    onReset?: () => void;
    onCancel?: () => void;
    onJobStart?: () => void;
};

function BackupToolPBMSetup({
    cluster,
    form,
    onFormShow,
    onFinish,
    onReset,
    onCancel,
    onJobStart,
}: BackupToolPBMInstallProps) {
    const [showForm, setShowForm] = useState<boolean>(false);
    const { loading, setup } = usePBMSetup({
        cluster,
        form,
        onSuccess: onJobStart,
    });
    const handleCancelClick = () => {
        setShowForm(false);
        onCancel?.();
    };

    const handleContinueClick = () => {
        setShowForm(true);
        onFormShow?.();
    };

    const handleInstallClick = async () => {
        await setup();
    };
    return (
        <AppSpin spinning={loading}>
            <BackupToolJobProgress
                command={CmonJobInstanceCommand.PBMAGENT}
                cluster={cluster}
                showReset={true}
                onFinish={onFinish}
                onReset={onReset}
                title={'Installing MongoDB Percona Backup'}
                failedMessage={'Installing MongoDB Percona Backup has failed'}
                successMessage={
                    'Installing MongoDB Percona Backup has finished successfully'
                }
                jobId={form.getFieldValue('__backupToolJobId__')}
                fallback={
                    showForm ? (
                        <BackupToolPromoCard
                            title={
                                <TypographyText>
                                    Install new backup tool
                                </TypographyText>
                            }
                            onInstallClick={handleInstallClick}
                            onCancelClick={handleCancelClick}
                        >
                            <BackupToolPBMSetupForm />
                        </BackupToolPromoCard>
                    ) : (
                        <BackupToolPromoCard
                            intoCommand={CmonJobInstanceCommand.PBMAGENT}
                            title={
                                <TypographyText primary={true}>
                                    Install new backup tool
                                </TypographyText>
                            }
                            onContinueClick={handleContinueClick}
                            iconType={'install'}
                            bg={'circles-bottom-right'}
                        />
                    )
                }
            />
        </AppSpin>
    );
}
